import { hasControlCharacter } from "../values/control-characters";

export const BATCH_LABEL_PATH = "/scan";
export const BATCH_LABEL_QUERY_KEY = "batch";

const MAX_BATCH_LABEL_PAYLOAD_LENGTH = 200;
const MAX_LABEL_LINK_LENGTH = 300;
const SCANNABILITY_PROBE_ORIGIN = "https://label.invalid";
const LINK_PATTERN = /^https?:\/\//i;

export function batchScanPath(batchNumber: string): string {
  return `${BATCH_LABEL_PATH}?${new URLSearchParams({ [BATCH_LABEL_QUERY_KEY]: batchNumber })}`;
}

export function buildBatchLabelUrl(origin: string, batchNumber: string): string {
  return new URL(batchScanPath(batchNumber), origin).toString();
}

function parseUrl(text: string): URL | null {
  try {
    return new URL(text);
  } catch {
    return null;
  }
}

export function isPlausibleBatchNumber(text: string): boolean {
  return text.length > 0 && text.length <= MAX_BATCH_LABEL_PAYLOAD_LENGTH && !hasControlCharacter(text);
}

export function parseBatchQueryValue(value: string | null): string | null {
  const batchNumber = (value ?? "").trim();
  return isPlausibleBatchNumber(batchNumber) ? batchNumber : null;
}

function onlyBatchNumber(url: URL): string | null {
  const batchNumbers = url.searchParams.getAll(BATCH_LABEL_QUERY_KEY);
  return batchNumbers.length === 1 ? parseBatchQueryValue(batchNumbers[0]) : null;
}

function batchNumberFromLink(text: string): string | null {
  const url = parseUrl(text);
  return url?.pathname === BATCH_LABEL_PATH ? onlyBatchNumber(url) : null;
}

export function parseBatchLabelLink(payload: string): string | null {
  const text = payload.trim();
  return LINK_PATTERN.test(text) ? batchNumberFromLink(text) : null;
}

export function parseBatchLabelPayload(payload: string): string | null {
  const text = payload.trim();
  return LINK_PATTERN.test(text) ? batchNumberFromLink(text) : parseBatchQueryValue(text);
}

export function isScannableBatchNumber(batchNumber: string): boolean {
  const link = buildBatchLabelUrl(SCANNABILITY_PROBE_ORIGIN, batchNumber);
  return link.length <= MAX_LABEL_LINK_LENGTH && parseBatchLabelLink(link) === batchNumber;
}
